import { v4 as uuidv4 } from 'uuid';
import { assignProps, removeItemByCode } from '@/utils/resultsHelper';
import { states } from '@/constants/lifecycle';
import withDraft from '@/utils/draftHelper';
import { workspaceActions } from '@/workspaces/constants';
import { responseError } from '@/utils/errors';
import crushRequestFields from '../../forms/state/state';
import { findWorkspaceRequest, newRequestWorkspace } from './state';

const newWorkspaceRequest = withDraft((draft, action) => {
  const item = newRequestWorkspace(action);
  draft.newRequestCode = uuidv4();

  if (action.form?.readStatus === states.SUCCESS) {
    crushRequestFields(item, action.form);
  }
  draft.requests.workspaces.results.push(item);
});

const newWorkspaceRequestSuccess = withDraft((draft, action) => {
  const item = findWorkspaceRequest(draft, action);
  assignProps(item, action.result);
  item.saveStatus = states.SUCCESS;
  item.saveErrors = [];
  item.isDirty = false;
});

const requestWorkspace = withDraft((draft, action) => {
  const item = findWorkspaceRequest(draft, action);
  item.saveStatus = states.PENDING;
  item.saveErrors = [];
  item.steps.activeStepIndex += 1;
});

const closeWorkspaceRequest = withDraft((draft, { code }) => {
  draft.requests.workspaces.results = removeItemByCode(draft.requests.workspaces.results, { code });
});

const newWorkspaceRequestError = withDraft((draft, action) => {
  const item = findWorkspaceRequest(draft, action);
  item.saveStatus = states.ERROR;
  item.saveErrors = [responseError(action)];
});

export default {
  [workspaceActions.CLOSE_REQUEST_WORKSPACE]: closeWorkspaceRequest,
  [workspaceActions.DESTROY_REQUEST_WORKSPACE]: closeWorkspaceRequest,
  [workspaceActions.NEW_WORKSPACE_REQUEST]: newWorkspaceRequest,
  [workspaceActions.REQUEST_WORKSPACE]: requestWorkspace,
  [workspaceActions.REQUEST_WORKSPACE_ERROR]: newWorkspaceRequestError,
  [workspaceActions.REQUEST_WORKSPACE_SUCCESS]: newWorkspaceRequestSuccess,
};
